import { render, staticRenderFns } from "./OrderDigest.vue?vue&type=template&id=3be22725&"
import script from "./OrderDigest.vue?vue&type=script&lang=js&"
export * from "./OrderDigest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports